var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.871,
    height: 30,
    viewBox: "0 0 23.871 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account-icon",
    transform: "translate(-64 0.18)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98",
    "data-name": "Elipse 98",
    cx: 7.807,
    cy: 7.807,
    r: 7.807,
    transform: "translate(68.541 -0.18)",
    fill: "#5d00c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20444",
    "data-name": "Caminho 20444",
    d: "M75.935,298.667c-6.589.007-11.928,5-11.935,11.161a1.285,1.285,0,0,0,1.326,1.24H86.545a1.285,1.285,0,0,0,1.326-1.24C87.863,303.667,82.524,298.674,75.935,298.667Z",
    transform: "translate(0 -281.248)",
    fill: "#5d00c3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.4a0002e3c22d874d776cb071fec793a7.svg";
export { ForwardRef as ReactComponent };